/**
 * Carte Leaflet + fond Google stylé (Leaflet.GoogleMutant).
 *
 * Remplace l'ancien rendu Google Maps JS (instable : un marqueur sans icône
 * faisait planter `setIcon`). Leaflet gère les marqueurs/popups de façon stable ;
 * le fond reste Google (via GoogleMutant) pour conserver les styles Snazzy
 * custom (champ ACF `styles`). Lit les MÊMES attributs data-* que le composant
 * <x-map> : data-center, data-zoom, data-markers, data-styles.
 *
 * Libs chargées en CDN (Leaflet, GoogleMutant) + l'API Google Maps JS
 * (nécessaire à GoogleMutant). On attend que `google.maps` soit prête avant
 * d'instancier (pas de dépendance à un callback global).
 */

function parseStyles(raw) {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length ? parsed : null;
  } catch (e) {
    return null;
  }
}

function buildMap(el) {
  const L = window.L;
  if (!L || el.dataset.leafletReady) return;
  el.dataset.leafletReady = '1';

  const center = JSON.parse(el.dataset.center || '{"lat":45.5017,"lng":-73.5673}');
  const zoom = parseInt(JSON.parse(el.dataset.zoom || '12'), 10);
  const markers = el.dataset.markers ? JSON.parse(el.dataset.markers) : [];
  const styles = parseStyles(el.dataset.styles);

  const map = L.map(el, {
    center: [center.lat, center.lng],
    zoom,
    scrollWheelZoom: false,
  });

  // Fond Google (mêmes styles que la maquette). `styles` undefined = fond par défaut.
  L.gridLayer
    .googleMutant({ type: 'roadmap', styles: styles || undefined })
    .addTo(map);

  let openPopup = null;

  markers.forEach((m) => {
    const lat = m.lat != null ? m.lat : m.position && m.position.lat;
    const lng = m.lng != null ? m.lng : m.position && m.position.lng;
    if (lat == null || lng == null) return;

    const opts = {};
    if (m.icon && m.icon.url) {
      opts.icon = L.icon({
        iconUrl: m.icon.url,
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32],
      });
    }

    const marker = L.marker([lat, lng], opts).addTo(map);

    if (m.link) {
      marker.on('click', () => {
        window.location.href = m.link;
      });
    } else if (m.content) {
      marker.bindPopup(m.content);
    }
  });

  // Marqueur unique → on centre dessus.
  if (markers.length === 1) {
    const m = markers[0];
    const lat = m.lat != null ? m.lat : m.position && m.position.lat;
    const lng = m.lng != null ? m.lng : m.position && m.position.lng;
    if (lat != null && lng != null) map.setView([lat, lng], zoom);
  }
}

function initLeafletMaps() {
  document.querySelectorAll('.google-map').forEach(buildMap);
}

function whenGoogleReady(cb) {
  if (window.google && window.google.maps) return cb();
  let tries = 0;
  const timer = setInterval(() => {
    if (window.google && window.google.maps) {
      clearInterval(timer);
      cb();
    } else if (tries++ > 200) {
      // ~10 s : l'API Google n'a pas répondu (clé/domaine ?). On s'arrête
      // proprement sans casser la page.
      clearInterval(timer);
    }
  }, 50);
}

function ready(cb) {
  if (document.readyState !== 'loading') cb();
  else document.addEventListener('DOMContentLoaded', cb);
}

ready(() => {
  if (!document.querySelector('.google-map')) return;
  whenGoogleReady(initLeafletMaps);
});
